import { render, staticRenderFns } from "./RoomAssignmentRoomType.vue?vue&type=template&id=4d28b5cb&scoped=true&"
import script from "./RoomAssignmentRoomType.vue?vue&type=script&lang=js&"
export * from "./RoomAssignmentRoomType.vue?vue&type=script&lang=js&"
import style0 from "./RoomAssignmentRoomType.vue?vue&type=style&index=0&id=4d28b5cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d28b5cb",
  null
  
)

export default component.exports